export default __webpack_public_path__ + "static/3-dc564df66976f884fddafb7683b5c501.jpg";